<template>
  <div class="upper_left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      background-color="#072A59"
      text-color="#888888"
      active-text-color="#ffffff"
      class="el-menu-vertical-demo" >
      <el-menu-item index="1" @click="toNewRouter('upper-account-superior-account-management')">
        <i class="el-icon-damai-icon-test"></i>
        <span slot="title">账号管理</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('upper-account-superior-role-management')">
        <i class="el-icon-damai-jiaose"></i>
        <span slot="title">角色管理</span>
      </el-menu-item>

      <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 20px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div>
    </el-menu>
  </div>
</template>

<script>
import navMixin from '../../../../utils/nav'
import {bus} from '../../../../utils/bus'

const indexOfRouterNameEntities = Object.entries({
  '1': ['upper-account-superior-account-management', 'upper-account-superior-account-add', 'upper-account-superior-account-modify'],
  '2': ['upper-account-superior-role-management', 'upper-account-superior-role-add', 'upper-account-superior-role-modify'],
})
export default {
  name: 'upper-strata-account-manage-nav',
  mixins: [navMixin],
  data () {
    return {
      isCollapse: false,
      indexOfRouterNameEntities,
      permissionCodes: ''
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
  },
  computed:{
    defaultActiveMenuIndex () {
      const {name: routeName} = this.$route
      const entity = indexOfRouterNameEntities
        .find(([, routeNames]) => {
          if (routeNames instanceof Array) {
            return routeNames.indexOf(routeName) >= 0
          } else {
            return routeNames === routeName
          }
        })
      return entity && entity[0]
    }
  },
  methods: {
    toNewRouter (name, params) {
      this.$router.push({
        name: name,
        params: params
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .upper_left_nav {
    height: 100%;
    background-color: #072A59;
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 220px;
    }
    .el-submenu__title {
      /*border-left: 5px solid #FFFFFF;*/
      text-align: left;
    }
    .el-menu-item {
      /*border-left: 5px solid #FFFFFF;*/
      text-align: left;
    }
    .el-submenu .el-menu-item {
      text-align: left;
      padding-left: 80px!important;
    }
    .el-menu-item .is-active {
      background-color: #ecf5ff;
    }
    .is-active, .el-menu-item:hover {
      /*border-left: 5px solid #00A0E6 !important;*/
      color: #ffffff;
      /*.el-submenu__title {*/
      /*border-left: 0 !important;*/
      /*}*/
    }
    .el-menu {
      border-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/AccountManage/AccountManageNav.vue